import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { images } from "../assets";
import APIService from "../services/APIService";
import SImage from "./SImage";

const Agency = ({ data }) => {

  console.log(data);
  return (
    <div className="p-4 bg-white shadow-lg rounded-xl hover:shadow-2xl">
      <div className="flex flex-1">
        <div className="min-w-[130px] max-w-[130px]  h-[130px]">
          <SImage
            src={data?.avatar}
            className="w-full h-full rounded-xl"
            alt=""
          />
        </div>
        <div className="flex flex-col items-start justify-between ml-4">
          <div className="flex flex-col">
            <span className="text-sm	font-bold text-[#222222] not-italic capitalize text-two-lines">
              {data.name}
            </span>
            <span className="text-xs	 not-italic font-normal capitalize text-[#119AE2] text-two-lines">
              Địa chỉ : {data?.address}
            </span>
            <span className="text-xs	">{data?.description}</span>
          </div>
          <div className="flex items-center justify-center ">
            <Link to={`/agency-details?agencyId=${data.id}`}>
              <button className="w-[100px] h-[30px] justify-center flex items-center p-2 rounded-[30px] bg-[#119AE2]">
                <span className="text-sm font-bold text-[#FFFFFF] not-italic capitalize ">
                  Chi tiết
                </span>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Agency;
